<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select v-model="tableParams.channelId" :channelType="2"/>
      <search-channel-monitor-select v-model="tableParams.monitorId" :channel-id="tableParams.channelId"/>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <template v-if="v.field === 'showUrl' || v.field === 'clkUrl'">
              <div class="tab-editor">
                <el-tooltip effect="dark" :content="scope.row[v.field]" placement="top-start">
                  <div style="max-width: 500px;">
                    <span @click="handleCopy">{{ scope.row[v.field] }}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
            <span v-else-if="v.field === 'linkPlatform'">
              {{ linkTypeMap[scope.row[v.field]] || '-' }}
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
            <el-button @click="deleteData(scope.row)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;"/>
    </div>

    <m-form @submit="toQuery" ref="form" title="投放链接 "/>

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import mForm from './form'

import initTableMixin from '@/mixins/initTable'
import {linkTypeMap} from "@/const/link-type";
import SearchChannelSelect from "@/components/SearchChannelSelect/index.vue";
import SearchChannelMonitorSelect from "@/components/SearchChannelMonitorSelect/index.vue";
import {deleteLink, deleteMonitor} from "@/api/manage/link/link";

export default {
  name: 'channel/monitor',
  computed: {
    linkTypeMap() {
      return linkTypeMap
    }
  },
  components: {
    TableColumn,
    mForm,
    SearchChannelSelect,
    SearchChannelMonitorSelect
  },
  mixins: [initTableMixin],
  data() {
    return {
      columns: [
        {field: 'monitorId', title: '监测编号'},
        {field: "channelName", title: "渠道编号"},
        {field: "linkName", title: "应用链接名称"},
        {field: 'dspName', title: '广告主名称'},
        {field: "linkPlatform", title: "平台"},
        {field: "unitPrice", title: "投放单价"},
        {field: "showUrl", title: "展示监测链接"},
        {field: "clkUrl", title: "点击监测链接"},
        {field: "remark", title: "备注"},
        {field: "createTime", title: "创建时间"},
        {field: "updateTime", title: "修改时间"},
      ]
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  watch: {
    // 监听 channelId 的变化
    'tableParams.channelId'(newVal, oldVal) {
      // 当 channelId 变化时，重置 monitorId 的值为 ''
      if (newVal !== oldVal) {
        this.tableParams.monitorId = '';
      }
    }
  },
  methods: {
    beforeInit() {
      this.tableUrl = 'channel/monitor/getMonitorList'
      return true
    },
    add() {
      this.$refs.form.show()
    },
    update(row) {
      this.$refs.form.show(row)
    },
    deleteData(row){
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMonitor(row.monitorId).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.init()
          } else {
            this.$message({
              type: 'error',
              message: '删除异常!'
            });
          }
        })
      })
    },
    handleCopy(e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select, & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.tab-editor {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
